module.exports = __webpack_public_path__ + "img/arrow-right.80ffa682.svg";